export default {
    actions: {
        saleForPrint({ commit }, payload) {
            commit("SET_SALE", payload);
        },
    },
    getters: {
        currentSale(state) {
            return state.sale;
        },
    },
    mutations: {
        SET_SALE(state, data) {
            state.sale = data;
        },
    },
    namespaced: true,
    state: {
        sale: {},
    },
};
